import {
    Button,
    Dropdown,
    FormGroup,
    Input,
    InputPlaceholder,
    Modal,
    ModalActions,
    ModalContent,
} from '@/platform/ui';
import { Deferred, useForm, usePage } from '@inertiajs/react';

const AttachModal = ({ onClose }) => {
    const { auth, contacts } = usePage().props;
    const { data, setData, post, errors, processing } = useForm({});

    const handleSubmit = () => {
        post(
            `/customers/${auth.user.selected_customer_id}/datahub-invitees/attach`,
            {
                onSuccess: () => onClose(),
            }
        );
    };

    return (
        <Modal open={true} onClose={onClose}>
            <ModalContent>
                <FormGroup>
                    <Deferred
                        data={['contacts']}
                        fallback={
                            <InputPlaceholder
                                label='Contactpersoon'
                                placeholder='Contactpersonen worden geladen...'
                            />
                        }
                    >
                        <Dropdown
                            label='Contactpersoon'
                            value={data?.contact_id || ''}
                            options={contacts?.map(contact => ({
                                id: contact.id,
                                name: contact.name,
                            }))}
                            onChange={value => setData('contact_id', value)}
                            error={errors?.contact_id}
                        />
                    </Deferred>
                    <Input
                        label='Datahub invitee ID'
                        value={data?.datahub_id || ''}
                        required
                        onChange={event =>
                            setData('datahub_id', event.target.value)
                        }
                        error={errors?.datahub_id}
                    />
                </FormGroup>
            </ModalContent>
            <ModalActions>
                <Button
                    variant='primary'
                    onClick={handleSubmit}
                    loading={processing}
                >
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default AttachModal;
